import { useMemo } from 'react'

const useIsMobile = () => {
  return useMemo(() => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), [])
}

export default useIsMobile
